var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7268 24.2541C62.1007 34.5055 58.1213 47.2223 49.0378 54.143C39.9111 61.0637 25.6804 62.1884 16.5969 55.7002C7.55671 49.2553 3.66381 35.1543 7.42695 24.3407C11.1901 13.4838 22.6093 5.91422 33.6392 6.00073C44.7124 6.1305 55.3962 13.9596 58.7268 24.2541Z",
    fill: "url(#paint0_linear_419_5939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4863 33.954C37.2401 34.9724 36.0768 35.6921 33.7501 37.1316C31.5008 38.5229 30.3763 39.2187 29.4699 38.9391C29.0952 38.8234 28.7538 38.6038 28.4785 38.3012C27.8125 37.5697 27.8125 36.1506 27.8125 33.3125C27.8125 30.4744 27.8125 29.0553 28.4785 28.3237C28.7538 28.0212 29.0952 27.8016 29.4699 27.686C30.3763 27.4063 31.5008 28.102 33.7501 29.4934C36.0768 30.9328 37.2401 31.6526 37.4863 32.6709C37.5879 33.0913 37.5879 33.5337 37.4863 33.954Z",
    stroke: "#B8EF36",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1213 30.875C48.125 31.6389 48.125 32.4501 48.125 33.3125C48.125 40.5897 48.125 44.2284 45.8643 46.4893C43.6034 48.75 39.9647 48.75 32.6875 48.75C25.4102 48.75 21.7715 48.75 19.5108 46.4893C17.25 44.2284 17.25 40.5897 17.25 33.3125C17.25 26.0352 17.25 22.3965 19.5108 20.1358C21.7715 17.875 25.4102 17.875 32.6875 17.875C33.5499 17.875 34.3611 17.875 35.125 17.8788",
    stroke: "#B8EF36",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0625 16.25L44.4816 17.3827C45.0312 18.8679 45.306 19.6105 45.8477 20.1523C46.3895 20.694 47.1321 20.9688 48.6174 21.5184L49.75 21.9375L48.6174 22.3566C47.1321 22.9062 46.3895 23.181 45.8477 23.7227C45.306 24.2645 45.0312 25.0071 44.4816 26.4923L44.0625 27.625L43.6434 26.4923C43.0938 25.0071 42.819 24.2645 42.2773 23.7227C41.7355 23.181 40.9929 22.9062 39.5076 22.3566L38.375 21.9375L39.5076 21.5184C40.9929 20.9688 41.7355 20.694 42.2773 20.1523C42.819 19.6105 43.0938 18.8679 43.6434 17.3827L44.0625 16.25Z",
    stroke: "#B8EF36",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_419_5939",
    x1: 32.9583,
    y1: 6,
    x2: 32.9583,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiVideoIcon);
export default __webpack_public_path__ + "static/media/ai-video-icon.a8f49a69f6e43d6d1b0cf128515122e0.svg";
export { ForwardRef as ReactComponent };